"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    heading: {
      marginBottom: "".concat(theme.spacing(5), "px !important"),
      marginTop: '0 !important'
    }
  };
});
var ProductRecommendationCarouselEditConfig = {
  emptyLabel: 'Product Recommendation Carousel',
  isEmpty: function isEmpty(props) {
    return true;
  }
};
var ProductRecommendationCarousel = function ProductRecommendationCarousel(_ref) {
  var typeId = _ref.typeId,
    anchorId = _ref.anchorId,
    headline = _ref.headline;
  var classes = useStyles();
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-recommended-products"
  }, headline && __jsx("h2", {
    className: classes.heading,
    dangerouslySetInnerHTML: {
      __html: headline.slice(0, 90)
    }
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/productRecommendationCarousel')(ProductRecommendationCarousel, ProductRecommendationCarouselEditConfig);
exports.default = _default;